import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "grade-levels",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "grade-levels" */ "AdminSettings/routes/GradeLevelsWrapper/routes/GradeLevels/components"
      ),
    ])
      .then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
      .catch(err => {
        throw err;
      })
  ),
  childRoutes: [],
});
